import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

//image
import YellowShirtImg1 from '../../assets/img/route104-yellowshirt1.png';
// import YellowShirtImg2 from '../../assets/img/route104-yellowshirt2.png';

import TitleIcon from '../../assets/img/title-icon.png';

const YellowShirt = ({language}) => {
    return (
        <section className="yellow-shirt">
            <Container className='my-5'>
                {language === "Chinese"? <h2><span><img className='title-icon' src={TitleIcon} alt="" /></span>獎勵辦法</h2> : <h2>AWARDS</h2>}
                <Row className='align-items-center my-1'>
                    <Col md={6}>
                        <img className='yellow-shirt1' src={YellowShirtImg1} alt={language === "Chinese" ? "黃衫" : "Yellow Jersey"} />
                    </Col>
                    <Col md={6} className='ps-5'>
                        <h3 className='theme-color'>{language === "Chinese"? "103K挑戰組－黃衫爭霸賽" : "103K The Race – Yellow Jersey"}<span className='theme-color top'>TOP</span></h3>
                        {/* <h4 className='theme-color'><em>{language === "Chinese"? "限額80名" : "Limited to 80 participants"}</em></h4> */}
                        {language === "Chinese" ? <p>❶ 所有選手不得超越前導車；控燈交管僅提供前方領先選手，落後之選手須按照交通號誌與規章行進。</p>
                            : <p>❶ No rider may pass the lead vehicle. Traffic light control is provided for the leading riders only; riders who fall behind must obey traffic signals and road regulations.</p>}
                        <p>{language === "Chinese"? "❷ 依大會計時成績排名，男女各取前三名，由環法車手上台頒發獎座；總冠軍另可榮獲以下獎項及代表席次：" : "❷ Rankings are based on official timing. The top three men and top three women will receive trophies on stage, presented by Tour de France riders. The overall champion will also receive:"}</p>
                        <ul>
                            <li className='text-danger'>{language === "Chinese"? "前往法國參加2027 L'Étape France 錦標賽資格（僅總冠軍享有席次，機票及住宿自理）" : "A spot at the 2027 L'Étape France Championship in France (overall champion only; flights and accommodation at own expense)"}</li>
                            <li>{language === "Chinese"? "舞台授獎儀式" : "On-stage award ceremony"}</li>
                            <li>{language === "Chinese"? "授予環法最高榮譽黃衫" : "The Tour de France's highest honor, the Yellow Jersey"}</li>
                            <li>{language === "Chinese"? "獎座" : "Trophy"}</li>
                        </ul>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default YellowShirt
